import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CluNumpadDialogComponent } from './clu-numpad-dialog.component';

@Injectable()
export class CluNumpadDialogService {
    constructor(
        private _matDialog: MatDialog,
    ) {
    }

    openNumpadDialog(options?: { randomize?: boolean, length?: number }) {
        let CC_HEIGHT = window.innerHeight && window.innerHeight < 700 ? '100%' : '700px';
        return new Promise<string>((resolve, reject) => {
            this._matDialog.open(CluNumpadDialogComponent, {
                autoFocus: false, 
                disableClose: true, 
                width: '100%', 
                maxWidth: '700px', 
                minHeight: CC_HEIGHT, 
                maxHeight: CC_HEIGHT, 
                height : CC_HEIGHT,
                data: { 
                    randomize: !!options && !!options.randomize && options.randomize === true,
                    length: !!options ? options.length : undefined 
                } 
            }).afterClosed().subscribe((result?: any) => {
                resolve(result);
            });
        });
    }
}
